import { Link as RouterLink } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import {
  Alert,
  Box,
  Card,
  Container,
  Grid,
  Link as MuiLink,
  Typography,
} from '@mui/material';
// components
import HeaderBreadcrumbs from '../../components/header-breadcrumbs';
import { Seo } from '../../components/seo';
// sections
import { DeleteAccForm } from '../../sections/auth/delaccount';

// ----------------------------------------------------------------------

const ILLUSTRATION = '/assets/illustrations/illustration_login.png';

// ----------------------------------------------------------------------

export default function DeleteAccount() {
  const pageTitle = 'Delete Account';

  return (
    <>
      <Seo
        title={pageTitle}
        description="Request permanent deletion of your ASAP UAE account and the personal data held against it."
        path="/delete-account/"
      />

      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={pageTitle}
          headingComponent="h1"
          links={[
            {
              name: 'Home',
              href: '/',
            },
            { name: pageTitle },
          ]}
        />

        <Grid container spacing={{ xs: 4, md: 6 }} sx={{ alignItems: 'stretch' }}>
          {/* Decorative panel. Hidden on phones, where the form is the only
              thing on the page that matters. */}
          <Grid size={{ xs: 12, md: 5 }} sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Card
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                height: '100%',
                p: { md: 6 },
                textAlign: 'center',
                bgcolor: (theme) => alpha(theme.palette.grey[500], 0.08),
              }}
            >
              <Typography variant="h5">Deletion is permanent</Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                The account and the personal data behind it are removed from our systems. There is no way to restore
                them afterwards.
              </Typography>

              <Box
                component="img"
                src={ILLUSTRATION}
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
                sx={{ width: '100%', maxWidth: 280, height: 'auto', mt: 1 }}
              />
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 7 }}>
            <Card sx={{ height: '100%', p: { xs: 3, md: 5 } }}>
              <Typography component="h2" variant="h5" sx={{ mb: 1.5 }}>
                Delete your ASAP UAE account
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
                Confirm with your username and password. You will not be able to sign in again once the request is
                processed. If you only need your details corrected or your course access cancelled,{' '}
                <MuiLink component={RouterLink} to="/contact-us">
                  contact us
                </MuiLink>{' '}
                instead. What we hold is listed in the{' '}
                <MuiLink component={RouterLink} to="/privacy/">
                  privacy policy
                </MuiLink>
                .
              </Typography>

              <Alert severity="warning" sx={{ mb: 4 }}>
                Deleting your account cannot be undone.
              </Alert>

              <DeleteAccForm />
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}